"use client";
import dynamic from "next/dynamic";
const Careers = dynamic(() => import("@/views/Careers"), { ssr: false });
export default Careers;
